module.exports = __webpack_public_path__ + "static/media/Notice of Proposal to Issue a Compliance Order - Luxstone Homes Inc - December 2021.768fecda.pdf";